import { index } from "~/api/contractBalanceReplenishmentHistory.js";
import * as types from "../mutation-types";
import store from "../../store";

export const state = {
  list: null,
  listGroupByUser: null,
  isLoading: false
};

export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_BALANCE_REPLENISHMENT_LIST](state, data) {
    state.list = data?.data?.data ?? data?.data ?? [];
  },
  [types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST_GROUP_USER](
    state,
    status
  ) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_BALANCE_REPLENISHMENT_LIST_GROUP_USER](state, data) {
    state.listGroupByUser = data?.data?.data ?? data?.data ?? [];
  }
};

export const actions = {
  async fetchContractBalanceReplenishmentHistory({ commit }, data = {}) {
    const activeContractId =
      data?.contractId || store.getters["contract/activeContract"]?.id;

    if (!activeContractId) {
      commit(types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST, false);
      return undefined;
    }

    if (data.typeId) {
      commit(types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST_GROUP_USER, true);
      try {
        const response = await index(activeContractId, data.typeId);
        commit(types.SET_CONTRACT_BALANCE_REPLENISHMENT_LIST_GROUP_USER, response);
        return response;
      } finally {
        commit(
          types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST_GROUP_USER,
          false
        );
      }
    } else {
      commit(types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST, true);
      try {
        const response = await index(activeContractId);
        commit(types.SET_CONTRACT_BALANCE_REPLENISHMENT_LIST, response);
        return response;
      } finally {
        commit(types.SET_IS_LOADING_CONTRACT_BALANCE_REPLENISHMENT_LIST, false);
      }
    }
  }
};

export const getters = {
  list: (state) => state.list,
  listGroupByUser: (state) => state.listGroupByUser,
  isLoading: (state) => state.isLoading
};
